<div class="content-container">
  <div class="form-section">
    <img
      src="assets/png/broadfactorLogo.png"
      alt="Broadfactor Logo"
      class="logo"
    />

    <form [formGroup]="recoverPasswordForm" class="form-content">
      <mat-form-field appearance="outline" class="input-outline">
        <mat-label>Nova Senha</mat-label>
        <input
          matInput
          [type]="hideNewPassword() ? 'password' : 'text'"
          formControlName="newPassword"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="toggleVisibility('newPassword')"
          [attr.aria-label]="'Toggle password visibility'"
        >
          <mat-icon>{{
            hideNewPassword() ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>

        @if (recoverPasswordForm.get('newPassword')?.hasError('required') &&
        recoverPasswordForm.get('newPassword')?.touched) {
        <mat-error>O campo senha é obrigatório.</mat-error>
        } @if (recoverPasswordForm.get('newPassword')?.hasError('minlength') &&
        recoverPasswordForm.get('newPassword')?.dirty) {
        <mat-error>A senha deve ter no mínimo 8 caracteres.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-outline">
        <mat-label>Confirmar Senha</mat-label>
        <input
          matInput
          [type]="hideConfirmationPassword() ? 'password' : 'text'"
          formControlName="confirmationPassword"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="toggleVisibility('confirmationPassword')"
          [attr.aria-label]="'Toggle password visibility'"
        >
          <mat-icon>{{
            hideConfirmationPassword() ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>

        @if
        (recoverPasswordForm.get('confirmationPassword')?.hasError('required')
        && recoverPasswordForm.get('confirmationPassword')?.touched) {
        <mat-error>O campo confirmar senha é obrigatório.</mat-error>
        } @if
        (recoverPasswordForm.get('confirmationPassword')?.hasError('minlength')
        && recoverPasswordForm.get('confirmationPassword')?.dirty) {
        <mat-error>A senha deve ter no mínimo 8 caracteres.</mat-error>
        } @if (passwordsDontMatch) {
        <mat-error>As senhas não coincidem.</mat-error>
        }
      </mat-form-field>

      <button
        mat-button
        type="submit"
        class="btn-primary"
        [disabled]="!recoverPasswordForm.valid"
        (click)="onSubmit()"
      >
        @if (isLoading()) {
        <mat-spinner diameter="24"></mat-spinner>
        } @else { Alterar senha }
      </button>
    </form>
    <div class="forgot-password">
      <a (click)="goToUrl()">Voltar para tela de login</a>
    </div>
  </div>
</div>
